import React from 'react'

import Link from '@cinch/oxd-components/link/src'
import Panel from '@cinch/oxd-components/panel/src'
import SVG from '@cinch/oxd-components/svg/src'

import QIcon from './icons/q.svg'

import * as styles from './jargon-card.module.css'

interface JargonCardProps {
  question: string
  summary: string
  uid: string
}

const JargonCard: React.FC<JargonCardProps> = ({ question, summary, uid }) => (
  <Panel className={styles.jargon} isPadded={false}>
    <div className={styles.jargonPanelHeader}>
      <SVG children={QIcon} hasGradient={true} size={24} />
    </div>
    <h4 className={styles.jargonQuestion}>{question}</h4>
    <div className={styles.jargonSummary}>{summary}</div>
    <Link to={`/jargon/${uid}`} className={styles.viewMoreLink}>
      <span>View more</span>
    </Link>
  </Panel>
)

export default JargonCard
